import { t } from "ttag";

import { useHasTokenFeature } from "metabase/common/hooks";
import type { PaletteSubPath } from "metabase/palette/types";

// Mirrors EmbeddingNav's own sub-page list and visibility conditions
// (frontend/src/metabase/admin/embedding/components/EmbeddingNav.tsx) so
// every sub-page reachable by browsing Admin > Embedding's own sidebar is
// also reachable by name from the global command palette -- only the
// top-level "/admin/embedding" was searchable before this (WCAG 2.4.5
// Multiple Ways).
export const useEmbeddingAdminPaths = (): PaletteSubPath[] => {
  const hasSimpleEmbedding = useHasTokenFeature("embedding_simple");

  const paths: (PaletteSubPath | null)[] = [
    hasSimpleEmbedding
      ? {
          key: "embedding-setup-guide",
          name: `${t`Embedding`} - ${t`Setup guide`}`,
          path: "/admin/embedding/setup-guide",
        }
      : null,
    hasSimpleEmbedding
      ? {
          key: "embedding-guest",
          name: `${t`Embedding`} - ${t`Guest embeds`}`,
          path: "/admin/embedding/guest",
        }
      : null,
    {
      key: "embedding-security",
      name: `${t`Embedding`} - ${t`Security`}`,
      path: "/admin/embedding/security",
    },
    {
      key: "embedding-themes",
      name: `${t`Embedding`} - ${t`Themes`}`,
      path: "/admin/embedding/themes",
    },
  ];

  return paths.filter((path): path is PaletteSubPath => path !== null);
};
